//
// Generated class ServiceChargeRuleFormat
//

/// <reference path="ServiceChargeRuleFormat_ManagedObject.ts" />

class ServiceChargeRuleFormat extends ServiceChargeRuleFormat_ManagedObject
{

}
